export const registerLink = '/register';
export const demoLink = '/request-demo';
